export default __webpack_public_path__ + "static/img-ml-vs-programming-43b26d697cfd461ad83dd6bf72112654.webp";